import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/auth';
import 'firebase/compat/functions';
import { isMobile } from 'react-device-detect';
import env from '../env';

const config = {
  apiKey: env('FIREBASE_API_KEY'),
  authDomain: env('FIREBASE_AUTH_DOMAIN'),
  databaseURL: env('FIREBASE_DATABASE_URL'),
  projectId: env('FIREBASE_PROJECT_ID'),
  storageBucket: env('FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: env('FIREBASE_MESSAGING_SENDER_ID'),
};

firebase.initializeApp(config);

export let functions = firebase.app().functions('asia-northeast1');

if (env('EMULATORS') === 'true' || env('CLOUD_FUNCTIONS_EMULATOR') === 'true') {
  functions.useEmulator('localhost', Number(env('CLOUD_FUNCTIONS_PORT')) || 5001);
}

// iOS/Android のブラウザは WebChannel のストリームを維持できず
// `WebChannelConnection RPC 'Listen' stream transport errored` で購読が落ちるため、
// long polling に固定する。PC は WebChannel のまま。
firebase.firestore().settings({
  experimentalForceLongPolling: isMobile,
  experimentalAutoDetectLongPolling: !isMobile,
  merge: true,
});

if (env('EMULATORS') === 'true') {
  firebase.firestore().useEmulator('localhost', 8080);
  firebase.auth().useEmulator('http://localhost:9099');
}

export type DocumentReferenceV8 = firebase.firestore.DocumentReference;
export { firebase };
